<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true" depressed>新しい{{ $route.name }}を作成</v-btn>
      </section>

      <v-card flat>
        <v-card-title>
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field
                v-model="filterKeyword.name"
                label="商品名"
                outlined clearable hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="filterItems"
          :sort-by="['updatedAt']"
          :sort-desc="[true]"
          :loading="loading"
          group-by="category"
          @click:row="onRowClick">
            <template v-slot:group.header="{ group, headers, isOpen, toggle }">
              <td>
                {{ group }}
                <v-btn icon x-small @click.stop="toggle">
                  <v-icon>{{ isOpen ? 'fas fa-chevron-circle-down' : 'fas fa-chevron-circle-up' }}</v-icon>
                </v-btn>
              </td>
              <td :colspan="headers.length -1"></td>
            </template>
            <template v-slot:item.publish="{ item }">
              <template v-if="item.publish">
                <v-icon color="green darken-2">far fa-check-circle</v-icon>
              </template>
            </template>
            <template v-slot:item.updatedAt="{ item }">
              {{ getDateTime(item.updatedAt) }}
            </template>
        </v-data-table>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-dialog v-model="dialog" fullscreen persistent scrollable>
        <v-card>
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <h3>
                商品概要
                <div class="ctrl-btn opened" @click="switchAccordion"></div>
              </h3>
              <section class="accordion_inner">
                <div class="py-2">
                  <v-combobox
                    ref="category"
                    label="商品カテゴリー"
                    v-model="editedItem.category"
                    :items="categories"
                    append-icon="fas fa-list-ol"
                    @click.stop="openSelected('category', true)"
                    readonly outlined hide-details="auto">
                  </v-combobox>
                </div>
                <div class="py-2">
                  <v-text-field
                    ref="name"
                    label="名称"
                    v-model="editedItem.name"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </div>
                <div class="py-2">
                  <v-text-field
                    ref="mainTitle"
                    label="メインタイトル"
                    v-model="editedItem.mainTitle"
                    :rules="[rules.required]"
                    class="required"
                    outlined hide-details="auto">
                  </v-text-field>
                </div>
                <div class="py-2">
                  <v-text-field
                    ref="subTitle"
                    label="サブタイトル"
                    v-model="editedItem.subTitle"
                    outlined hide-details="auto">
                  </v-text-field>
                </div>
                <div class="py-2">
                  <p class="label">商品の公開</p>
                  <toggle-button
                    v-model="editedItem.publish"
                    :labels="{checked: '公開', unchecked: '非公開'}"
                    color="#0277bd"
                    :value="editedItem.publish"
                    :sync="true"
                    :width="90" :height="30" :font-size="14" />
                </div>
              </section>
              <h3>
                ギャラリー
                <div class="ctrl-btn opened" @click="switchAccordion"></div>
              </h3>
              <section class="accordion_inner">
                <div class="py-2">
                  <ul class="list-inline gallery">
                    <li>
                      <Upload :file.sync="editedItem.mainPic" @lightbox="lightboxFunc" label="メイン画像" />
                    </li>
                    <li v-for="file in editedItem.files" :key="file.id">
                      <Upload
                        :file.sync="file.file"
                        :label.sync="file.name"
                        :labelEditable="true"
                        :deletable="true"
                        @lightbox="lightboxFunc"
                        @deleteFile="deleteFile(file)"
                        accept="image/*,.pdf" />
                    </li>
                    <li>
                      <v-btn tile icon outlined class="add-btn" @click.stop="addFile">
                        <v-icon>fas fa-plus</v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </div>
              </section>
              <h3>
                商品説明
                <div class="ctrl-btn opened" @click="switchAccordion"></div>
              </h3>
              <section class="accordion_inner">
                <div class="py-2">
                  <RichEditor
                    ref="description"
                    :content.sync="editedItem.description"></RichEditor>
                </div>
              </section>
              <h3>
                品目
                <div class="ctrl-btn opened" @click="switchAccordion"></div>
              </h3>
              <section class="accordion_inner">
                <div class="py-2">
                  <ul class="model-list">
                    <li v-for="(item, index) in editedItem.models" :key="index">
                      <div class="model-image">
                        <Upload :file.sync="item.mainPic" @lightbox="lightboxFunc" label="メイン画像" />
                      </div>
                      <ul class="model-row">
                        <li class="name">
                          <v-text-field
                            label="品名"
                            v-model="item.name"
                            :rules="[rules.required]"
                            class="required"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="serial">
                          <v-text-field
                            label="製品コード"
                            v-model="item.serial"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="code">
                          <v-text-field
                            label="品番"
                            v-model="item.code"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="size">
                          <v-text-field
                            label="サイズ"
                            v-model="item.size"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="color">
                          <v-text-field
                            label="色"
                            v-model="item.color"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="material">
                          <v-text-field
                            label="材質"
                            v-model="item.material"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="value">
                          <v-text-field
                            label="単価（税抜）"
                            type="number"
                            v-model="item.value"
                            :rules="[rules.required, rules.integer, rules.min0]"
                            class="required"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                        <li class="inventory">
                          <p class="label">在庫管理</p>
                          <toggle-button
                            v-model="item.inventory"
                            :labels="{checked: 'する', unchecked: 'しない'}"
                            color="#0277bd"
                            :value="item.inventory"
                            :sync="true"
                            :width="90" :height="30" :font-size="14" />
                        </li>
                        <li class="publish">
                          <p class="label">公開</p>
                          <toggle-button
                            v-model="item.publish"
                            :labels="{checked: '公開', unchecked: '非公開'}"
                            color="#0277bd"
                            :value="item.publish"
                            :sync="true"
                            :width="90" :height="30" :font-size="14" />
                        </li>
                        <li class="remark">
                          <v-text-field
                            label="備考"
                            v-model="item.remark"
                            outlined hide-details="auto">
                          </v-text-field>
                        </li>
                      </ul>
                      <div class="model-ctrl">
                        <v-btn tile icon @click="removeModel(item)">
                          <v-icon>fas fa-trash-alt</v-icon>
                        </v-btn>
                      </div>
                    </li>
                    <li class="pt-3">
                      <v-btn depressed @click="addModel">
                        <v-icon left>fas fa-plus-square</v-icon> 品目を追加
                      </v-btn>
                    </li>
                  </ul>
                </div>
              </section>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-footer">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" depressed>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" depressed>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" depressed>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { createProduct, updateProduct, deleteProduct, createModel, updateModel, deleteModel, createFile, updateFile, deleteFile } from '../graphql/mutations'
import { listProducts, listModels, listFiles } from '../graphql/queries'
import { onCreateProduct, onUpdateProduct, onDeleteProduct } from '../graphql/subscriptions'
import Upload from '@/components/Upload'
import RichEditor from '@/components/RichEditor'
import axios from 'axios'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '商品名', align: 'start', value: 'name' },
        { text: 'メインタイトル', align: 'start', value: 'mainTitle' },
        { text: '公開', align: 'start', value: 'publish' },
        { text: '更新日時', align: 'start', value: 'updatedAt' },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      editedIndex: -1,
      editedItem: {
        publish: false,
        models: [],
        files: [],
      },
      subscription: {},
      filterKeyword: {},
    }
  },
  prop: {},
  mounted: async function() {
    //一覧 query
    await this.getProducts()
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateProduct)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateProduct
        row.category = row.category || '未分類'
        this.desserts.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateProduct)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateProduct
        this.desserts.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteProduct)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteProduct
        this.desserts = this.desserts.filter(origin => origin.id !== row.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //商品名
        if (this.filterKeyword.name && item.name.indexOf(this.filterKeyword.name) < 0) continue
        map.push(item)
      }
      return map
    },
    product() {
      return {
        id: this.editedItem.id || null,
        category: this.editedItem.category || null,
        name: this.editedItem.name || null,
        mainTitle: this.editedItem.mainTitle || null,
        subTitle: this.editedItem.subTitle || null,
        mainPic: this.editedItem.mainPic || null,
        publish: this.editedItem.publish || false,
      }
    },
    categories() {
      const map = []
      this.desserts.forEach(e => {
        if (e.category && !map.find(m => m === e.category)) map.push(e.category)
      })
      return map
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //行選択
    async onRowClick(params) {
      try {
        this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
        //説明
        const url = await Storage.get('html/' + params.id + '-description.html')
        const content = await axios.get(url)
        params.description = content.data || ''
        //品目
        params.models = []
        await this.getModels(params.models, params.id)
        //作成日付降順でソート
        params.models.sort(function(a,b) {
          if (a.createdAt < b.createdAt) return -1
          if (a.createdAt > b.createdAt) return 1
          return 0
        })
        //ファイル
        params.files = []
        await this.getFiles(params.files, params.id)

        this.editedItem = Object.assign({}, params)
        delete this.editedItem.updatedAt
        delete this.editedItem.createdAt
        this.dialog = true
      } catch (e) {
        console.log(e)
      }
    },
    //保存
    async save() {
      try {
        this.saving = true
        const row = this.product
        let id = row.id
        //商品
        if (id) {
          await API.graphql(graphqlOperation(updateProduct, {input: row}))
          this.log({ type: this.$route.name, text: '[' + row.name + '] を更新しました' })
        //新規
        } else {
          delete row.id
          const ret = await API.graphql(graphqlOperation(createProduct, {input: row}))
          this.log({ type: this.$route.name, text: '[' + row.name + '] を追加しました' })
          id = ret.data.createProduct.id
        }
        //品目
        const origin = this.desserts.find(e => e.id === id)
        //オリジナルにのみ存在するものは削除
        if (origin) {
          //品目
          for (const model of origin.models) {
            if (!this.editedItem.models.find(e => e.id === model.id)) {
              await API.graphql(graphqlOperation(deleteModel, {
                input: { id: model.id }
              }))
            }
          }
          //ファイル
          for (const file of origin.files) {
            if (!this.editedItem.files.find(e => e.id === file.id)) {
              await API.graphql(graphqlOperation(deleteFile, {
                input: { id: file.id }
              }))
            }
          }
        }
        //追加と更新
        //品目
        for (const model of this.editedItem.models) {
          let child = this.getModel(model)
          if (child.id) {
            await API.graphql(graphqlOperation(updateModel, {input: child}))
          } else {
            delete child.id
            child.productID = id
            await API.graphql(graphqlOperation(createModel, {input: child}))
          }
        }
        //ファイル
        for (const file of this.editedItem.files) {
          let child = this.getFile(file)
          if (child.id) {
            await API.graphql(graphqlOperation(updateFile, {input: child}))
          } else {
            child.productID = id
            await API.graphql(graphqlOperation(createFile, {input: child}))
          }
        }
        //説明
        await Storage.put('html/' + id + '-description.html', this.editedItem.description)

        this.dialog = false
      } catch (e) {
        console.log(e)
        this.myAlert(e)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.name + 'を削除しますか？')) {
          //品目削除
          for (const model of this.editedItem.models) {
            if (model.id) {
              await API.graphql(graphqlOperation(deleteModel, {
                input: { id: model.id }
              }))
            }
          }
          //商品削除
          await API.graphql(graphqlOperation(deleteProduct, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[' + this.editedItem.name + '] を削除しました' })
          this.myAlert(this.editedItem.name + 'を削除しました', 'success')
          this.dialog = false
        }
      } catch (e) {
        console.log(e)
        this.myAlert(e)
      }
    },
    //品目データ
    getModel(model) {
      return {
        id: model.id || null,
        name: model.name || null,
        serial: model.serial || null,
        code: model.code || null,
        size: model.size || null,
        color: model.color || null,
        material: model.material || null,
        value: model.value || 0,
        inventory: model.inventory || false,
        publish: model.publish || false,
        remark: model.remark || null,
        mainPic: model.mainPic || null,
        remain: 0,
      }
    },
    //品目の追加
    addModel() {
      this.editedItem.models.push({
        mainPic: null,
        name: null,
        code: null,
        size: null,
        color: null,
        material: null,
        value: 0,
        inventory: true,
        publish: true,
        remark: null,
      })
    },
    //品目の削除（画面上のみ削除）
    removeModel(model) {
      this.editedItem.models = this.editedItem.models.filter(e => e !== model)
    },
    //ファイルデータ
    getFile(file) {
      return {
        id: file.id || null,
        name: file.name || null,
        file: file.file || null,
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      //this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
      this.editedItem.mainPic = null
      this.editedItem.description = null
      this.editedItem.publish = false
      this.editedItem.models = []
      //アコーディオンの全開
      document.querySelectorAll('h3 .ctrl-btn').forEach(e => e.classList.add('opened'))
      document.querySelectorAll('.accordion_inner').forEach(e => e.style.display = 'block')
      //スクロールのリセット
      this.scrollReset()
    },
    //スクロールを戻す
    scrollReset() {
      let container = document.getElementsByClassName('scroll-content')[0]
      container.scrollTop = 0
    },
    //アコーディオンの開閉
    switchAccordion(e) {
      const target = e.target.parentElement.nextSibling
      target.style.display = target.style.display == 'none' ? 'block' : 'none'
      e.target.classList.toggle('opened')
    },
    //商品の取得
    async getProducts(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listProducts, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listProducts.items) {
        data.publish = data.publish || false
        data.category = data.category || '未分類'
        this.desserts.push(data)
      }
      if (query.data.listProducts.nextToken) this.getProducts(query.data.listProducts.nextToken)
    },
    //品目の取得
    async getModels(target, productID, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listModels, {
        filter: {
          productID: { eq: productID }
        },
        limit: 500,
        nextToken: nextToken
      }))
      for (const data of query.data.listModels.items) {
        target.push(data)
      }
      if (query.data.listModels.nextToken) this.getModels(target, productID, query.data.listModels.nextToken)
    },
    //ファイルの取得
    async getFiles(target, productID, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listFiles, {
        filter: {
          productID: { eq: productID }
        },
        limit: 500,
        nextToken: nextToken
      }))
      for (const data of query.data.listFiles.items) {
        target.push(data)
      }
      if (query.data.listFiles.nextToken) this.getFiles(target, productID, query.data.listFiles.nextToken)
    },
    //ファイルの追加
    addFile() {
      this.editedItem.files.push({
        file: null,
        name: '名称未設定',
      })
    },
    deleteFile(item) {
      this.editedItem.files = this.editedItem.files.filter(e => e.id != item.id)
    },
  },
  components: {
    Upload,
    RichEditor,
  },
}
</script>

<style lang='scss' scoped>
h3 {
  position: relative;
  .ctrl-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    font-size: 20px;
    &:after {
      content: "\f139";
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
    }
    &.opened:after {
      content: "\f13a";
    }
  }
}
.gallery {
  li {
    margin-right: 10px;
    vertical-align: top;
    .add-btn {
      border-color: #DDD;
      border-radius: 5px;
      width: 120px;
      height: 120px;
    }
  }
}
.model-list {
  list-style: none;
  padding: 0;
  & > li {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #DDD;
    &:last-of-type {
      padding-bottom: 0;
      margin-bottom: 0;
      border-bottom: none;
    }
    .model-image {
      position: absolute;
      top: 5px;
      left: 0;
    }
    .model-row {
      list-style: none;
      padding: 0;
      letter-spacing: -.4em;
      margin-left: 140px;
      margin-right: 80px;
      li {
        letter-spacing: normal;
        display: inline-block;
        padding: 5px;
        &.name { width: 25%; padding-left: 0; }
        &.serial { width: 25%; }
        &.code { width: 25%; }
        &.size { width: 25%; }
        &.color { width: 25%; padding-left: 0; }
        &.material { width: 25%; }
        &.value { width: 25%; }
        &.remain { width: 25%; }
        &.remark { width: 100%; padding-left: 0; }
      }
    }
    .model-ctrl {
      position: absolute;
      right: 0;
      top: 15px;
      width: 70px;
      text-align: center;
    }
  }
}
@media screen and (max-width:1024px) {
  .model-list {
    & > li {
      .model-row {
        li {
          &.name { width: 50%; padding-left: 0; }
          &.serial { width: 50%; }
          &.code { width: 50%; padding-left: 0; }
          &.size { width: 50%; }
          &.color { width: 50%; padding-left: 0; }
          &.material { width: 50%; }
          &.value { width: 50%; padding-left: 0; }
          &.remain { width: 50%; }
          &.remark { width: 100%; padding-left: 0; }
        }
      }
      .model-ctrl {
        position: absolute;
        right: 0;
        top: 15px;
        width: 70px;
        text-align: center;
      }
    }
  }
}
</style>
